import { Box, CircularProgress } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../store/branchSlice";
import { useEffect } from "react";
import Localozation from "../components/Localisation";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { warehouseDocumentDetailAction } from "../asyncActions/warhouseActions";
import WarehouseDocumentList from "../components/WarehouseDocumentList";

function WarehouseDocumentListPage(){

    const dispatch = useDispatch()

    const {t} = useTranslation()

    const {
        dateFilter,
        warehouseDocuments,
        dataLoad
    } = useSelector(store => store.branch)

    useEffect(() => {
        dispatch(warehouseDocumentDetailAction(dateFilter.date))
    }, [dateFilter.date])


    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 5
        }}>
            <Localozation>
                <DatePicker
                    disabled={dataLoad}
                    label={t('label.document_date')}
                    value={dayjs(dateFilter.date) || null} 
                    onChange={(date) => {
                        dispatch(setDate(date))
                    }}
                />
            </Localozation>

            <Box sx = {{
            }}>
                {dataLoad ? <CircularProgress/> :
                    <WarehouseDocumentList documents={warehouseDocuments}/>
                }
                
            </Box>
        </Box>
    )
}

export default WarehouseDocumentListPage


